import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  section: {
    width: '100%',
    padding: theme.spacing(1, 0, 2),
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  chipsInline: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    paddingTop: theme.spacing(3),
  },
  paperActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  // O cabeçalho do Paper é flex: sem alinhar, o botão estica até a altura do título.
  smallButton: {
    alignSelf: 'center',
    fontSize: '0.75rem',
    padding: '5px 14px',
    minHeight: 0,
    lineHeight: 1.6,
    boxShadow: 'none',
  },
  help: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.8rem',
    marginTop: theme.spacing(0.5),
  },
  table: {
    'marginTop': theme.spacing(2),
    '& th': {
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.6)',
      whiteSpace: 'nowrap',
    },
  },
  highlightRow: {
    '& td': {
      fontWeight: 600,
      color: theme.palette.green.main,
    },
  },
  resultStageCell: {
    width: '38%',
  },
  resultShareCell: {
    color: 'rgba(0, 0, 0, 0.54)',
    whiteSpace: 'nowrap',
  },
  resultBarCell: {
    width: '30%',
    minWidth: 110,
  },
  resultBar: {
    height: 6,
    borderRadius: 3,
    backgroundColor: 'rgba(0, 0, 0, 0.07)',
    overflow: 'hidden',
  },
  resultBarFill: {
    display: 'block',
    height: '100%',
    borderRadius: 3,
  },
  toneGood: {
    backgroundColor: theme.palette.green.main,
  },
  toneBad: {
    backgroundColor: theme.palette.red.main,
  },
  toneNeutral: {
    backgroundColor: theme.palette.blue.main,
  },
  emptyState: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: theme.spacing(2),
  },
  inlineProgress: {
    marginLeft: theme.spacing(1),
    verticalAlign: 'middle',
  },
  switchCell: {
    paddingTop: theme.spacing(3),
  },
  filterRow: {
    padding: theme.spacing(0, 0, 1),
  },
  inviteRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2),
    margin: theme.spacing(2, 0),
  },
  inviteField: {
    flex: 1,
    maxWidth: 520,
  },
  // Declarado depois de smallButton para vencer o alignSelf: center e descer até a linha do campo.
  inviteButton: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    alignSelf: 'flex-end',
    marginBottom: theme.spacing(1),
  },
}));
